<template>
  <div class="row dvContent forAdmin">
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-import" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Import
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="#!"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label"><i class="material-icons">attach_file</i>Upload File</label>
                <input v-show="false" type="file" id="file" ref="file" v-on:change="onChangeFileUpload()" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xls"/>
                <input
                  :disabled="importing"
                  @click="clickFile()"
                  readonly
                  class="defaultModal-input" v-model="importFileName" placeholder="Click here to select excel template (.xls)" type="text" />
                <div class="defaultModal-helper-text hide">
                  <strong>NOTE: </strong>For importing file, it is required to use the excel template below.<br />
                  <a href="#">Download Excel Template</a>
                </div>
              </div>

            </div>
            <DataPrivacyConsent :dataPrivacy="dataPrivacy" :isAgreeDisabled="false"></DataPrivacyConsent>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">

          <a
            v-if="!importing"
            @click="doImportData()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Upload
          </a>

          <a
            v-if="importing"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Uploading...
          </a>

          <a
            :disabled="importing"
            @click="closeModal('modal-import')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-add-channel" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Add Channel
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Channel Name</label>
                <input v-model="channelName" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!addingChannel"
            @click="addChannel()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Add
          </a>

          <a
            v-if="addingChannel"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Adding...
          </a>

          <a
            :disabled="addingChannel"
            @click="closeModal('modal-add-channel')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-edit-channel" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Edit Channel
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Channel Name</label>
                <input v-model="selectedChannel.name" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!savingChannel"
            @click="updateChannel()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="savingChannel"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            :disabled="savingChannel"
            @click="closeModal('modal-edit-channel')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-add-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Add Team
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll"  href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Primary Name</label>
                <input class="browser-default defaultModal-input" type="text"  v-model="teamData.primaryName"/>
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Secondary Name</label>
                <input class="browser-default defaultModal-input" type="text"  v-model="teamData.secondaryName"/>
                <div class="defaultModal-helper-text">
                  Optional (e.g. Team Hustle)
                </div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Channel</label>
                <select class="browser-default defaultModal-input" v-model="teamData.channel">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(channel, index) in defaultChannels" :key="index" :value="channel.id">{{ channel.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Manager</label>
                <select class="browser-default defaultModal-input" v-model="teamData.manager">
                  <option value="" disabled selected>Select from list</option>
                  <!-- <option v-for="(user, index) in defaultUsers" :key="index" :value="user.id">{{ user.name }}</option> -->
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Monthly Target Group Referral</label>
                <input v-model="teamData.team_target_referrals" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Default Country</label>
                <select class="browser-default defaultModal-input" v-model="teamData.country">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(country, index) in defaultCountries" :key="index" :value="country.code">{{ country.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">

          <a
            v-if="!addingTeam"
            @click="addTeam()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Add
          </a>

          <a
            v-if="addingTeam"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Adding...
          </a>

          <a
            :disabled="addingTeam"
            @click="closeModal('modal-add-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>


    <div class="col s12 dvContentMain">
      <div class="dvSectionTitleOpts">
        <div class="dvSectionTitleOpts-title">
          <span class="icon-fs_world"></span>Manage Channels
        </div> <!-- dvSectionTitleOpts-title -->
        <div class="dvSectionTitleOpts-options">

          <a @click="showModal('modal-add-channel')" href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners"><span class="icon-action_add_circle"></span><div class="label">Add Channel</div></a>
          <a @click="showModal('modal-import')" href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners hide"><span class="icon-nav_arrow_up"></span><div class="label">Import</div></a>

        </div> <!-- dvSectionTitleOpts-options -->
      </div> <!-- dvSectionTitleOpts -->

      <div class="row">
        <div
          v-show="channels.length == 0 && !loading"
          class="col s12 dvBlankSection">
          <div class="dvBlankSectionBox flexCenterAll">
            <div class="dvBlankSection-content">
              <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
              <div class="dvBlankSection-text-primary center-align">
                There are no channels to display
              </div>
              <div class="dvBlankSection-text-secondary center-align">
                Try using the search box above to find what you are looking for.
              </div>
            </div>
          </div>
        </div>

        <ContentLoader :loading="loading" :firstLoad="firstLoad" v-if="true"></ContentLoader>

        <div class="row" v-for="(chunk, idx) in channelChunks" :key="idx">
          <div v-for="(channel, index) in chunk" :key="index" class="col s12 m12 l12 xl4">
            <div class="dvCardClient">
              <div class="dvCardClient-header" :class="{ 'dvCard-isArchive': channel.archive == 1 }">
                <div class="dvCardClient-header-name">
                  <div class="dvCardClient-header-name-info">
                    {{ channel.name }}
                  </div> <!-- dvCardClient-header-name-info -->
                </div> <!-- dvCardClient-header-name -->
                <div class="dvCardClient-header-menu">
                  <a
                    :name="'listview-menu-'+channel.id"
                    :ref="'tippy_menu'+channel.id"
                    class="waves-effect waves-light dvCardClient-header-link flexCenterAll" href="javascript:void(0)" ><span class="icon-nav_more_horz"></span></a>
                </div> <!-- dvCardClient-header-menu -->
              </div> <!-- dvCardClient-header -->
              <tippy
               v-bind:to="'listview-menu-'+channel.id"
               placement="left"
               offset="[10, 2]"
               interactive
               arrow
               trigger="click">
               <div class="morePopMenuBox-content ">

                 <router-link
                   class="morePopMenuBox-content-item"
                   :to="{ name:'admin_channel', params: { id: channel.id } }">
                   <span class="icon-editor_view"></span>View Channel
                 </router-link>

                 <a
                  @click="showChannel(channel)"
                  href="javascript:void(0)" class="morePopMenuBox-content-item">
                   <span class="icon-action_edit"></span>Edit Channel
                 </a>

                 <a
                  @click="showAddTeamModal(channel.id)"
                  href="javascript:void(0)" class="morePopMenuBox-content-item">
                   <span class="icon-action_add_box"></span>Add Team
                 </a>

                 <a
                  v-if="channel.archive == 0"
                  @click="confirm({
                    id: channel.id,
                    type: 'archive',
                    channelName: channel.name
                  })"
                  href="javascript:void(0)" class="morePopMenuBox-content-item">
                   <span class="icon-action_archive"></span>Archive
                 </a>

                 <a
                  v-if="channel.archive == 1"
                  @click="confirm({
                    id: channel.id,
                    type: 'unarchive',
                    channelName: channel.name
                  })"
                  href="javascript:void(0)" class="morePopMenuBox-content-item">
                   <span class="icon-action_archive"></span>Unarchive
                 </a>

               </div>
             </tippy>

              <div class="dvCardClient-content">
                <div class="dvCardClient-content-items">
                  <router-link
                    v-for="(team, teamIndex) in channel.teams" :key="teamIndex"
                    class="waves-effect waves-light dvCardClient-content-items-link"
                    :to="{ name:'admin_teams', params: { id: team.id } }">
                    <div>{{ team.team }}
                      <div class="dvCardClient-content-items-subtitle">{{ team.manager }}</div>
                    </div>
                    <div class="dvCardClient-count">{{ team.users_count }}</div>
                  </router-link>
                  </div> <!-- dvCardClient-content-items -->

                <div class="row dvCardClient-content-action">
                  <div class="col s6">
                    <router-link
                      tag="div"
                      class="waves-effect waves-dark btn-RoundCorners"
                      :to="{ name:'admin_channel', params: { id: channel.id } }">
                      <span class="icon-fs_search"></span><div class="label">View Channel</div>
                    </router-link>
                  </div> <!-- col -->
                  <div class="col s6">
                    <div @click="showAddTeamModal(channel.id)" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-action_add"></span><div class="label">Add Team</div></div>
                  </div> <!-- col -->
                </div> <!-- dvCardClient-content-action -->
              </div> <!-- dvCardClient-content -->
            </div> <!-- dvCardClient -->
          </div> <!-- col -->
        </div>





      </div> <!-- row -->
    </div> <!-- dvContentMain -->

    <div class="col s12 dvContentTools">
      <div class="dvContentTools-fx"></div>
      <div class="dvContentTools-content">

      </div>
      <div class="dvContentTools-page">
        <a disabled href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
        <a disabled href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
        <ToTop></ToTop>
      </div>

    </div>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>
  </div> <!-- dvContent -->
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import M from 'materialize-css'
  import _ from 'lodash'
  import ToTop from '@/components/totop/ToTop.vue'
  import DataPrivacyConsent from '@/components/DataPrivacyConsent.vue'

  export default {
    data() {
      return {
        dataPrivacy: {
          isAgree: false,
          isAgreeDisabled: false
        },
        addingTeam: false,
        defaultChannels: [],
        defaultUsers: [],
        defaultCountries: [],
        dialog: {
          show: false,
          title: '',
          body: '',
          action: '',
          id: ''
        },
        teamData: {
          primaryName: '',
          secondaryName: '',
          channel: '',
          manager: '',
          team_target_referrals: '',
          country: ''
        },
        savingChannel: false,
        addingChannel: false,
        channelName: '',
        selectedChannel: {},
        firstLoad: true,
        loadedCnt: 0,
        deleteDialog: {
          show: false,
          title: '',
          message: ''
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        loading: false,
        noRecordFound: false,
        search: '',
        selected: [],
        channels: [],
        archiving: false,
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Description', value: 'description' },
          {
            text: 'Action',
            value: 'action',
            sortable: false,
            width: 150
          }
        ],
        file: '',
        importing: false,
        importFileName: ''
      }
    },
    computed: {
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      },
      channelChunks(){
          return _.chunk(Object.values(this.channels), 3);
      }
    },
    methods: {
      clickFile (){
        this.importFileName = ''
        this.file = ''
        let file = document.getElementById('file');

        try {
          file.value = null;
        } catch(ex) {
          console.log(ex)
        }
        if (file.value) {
          file.parentNode.replaceChild(file.cloneNode(true), file);
        }

        file.click()
      },
      doImportData (){
        if(this.importFileName == ''){
          this.showMessage('Upload file is required.', 'sb-failed')
          return false
        }

        if(!this.dataPrivacy.isAgree){
          this.showMessage('Data privacy consent is required.', 'sb-failed')
          return false
        }


        this.file = this.$refs.file.files[0];
        this.importing = true

        let self = this

        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('is_agree_privacy_consent', this.dataPrivacy.isAgree);

        this.$http.secured.post('api/admin/import-referral',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
            this.closeModal('modal-import')
            this.getChannels()
            this.getDefaultData()
            // this.$emit('replacePhoto', response.data.photo)
          })
          .catch(error => {
            // this.showMessage(error.response.data, 'sb-failed')
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })

              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.importing = false
          })
      },
      onChangeFileUpload (){
        this.file = this.$refs.file.files[0];
        this.importFileName = ''
        if(this.file){
          this.importFileName = this.file.name
        }
      },
      addTeam (){
        if(this.teamData.primaryName == ''){
          this.showMessage('The primary name field is required.', 'sb-failed')
          return false
        }

        if(this.teamData.team_target_referrals == ''){
          this.showMessage('The monthly target group referral field is required.', 'sb-failed')
          return false
        }

        if(this.addingTeam){
          return false
        }

        let self = this
        self.addingTeam = true

        let url = '/api/admin/teams'

        let data = {
          name: this.teamData.primaryName,
          team_name: this.teamData.secondaryName,
          channel_id: this.teamData.channel,
          manager_id: this.teamData.manager,
          team_target_referrals: this.teamData.team_target_referrals,
          country: this.teamData.country
        }

        this.$http.secured.post(url, data)
          .then(response => {
            this.showMessage('Team has been successfully created', 'sb-success')
            this.closeModal('modal-add-team')
            this.teamData = {
              primaryName: '',
              secondaryName: '',
              channel: '',
              manager: '',
              team_target_referrals: '',
              country: ''
            }
            this.getChannels()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })

              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.addingTeam = false
          })
      },
      showAddTeamModal (channel){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })
        this.teamData.channel = channel
        this.showModal('modal-add-team')
      },
      confirm (action){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        if(action.type == 'archive'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to archive '+action.channelName+'?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_archive',
            positionBtn: 'Archive',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'unarchive'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to unarchive '+action.channelName+'?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_archive',
            positionBtn: 'Unarchive',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }

      },
      doConfirm (){
        this.dialog.show = false

        if(this.dialog.actionType == 'archive'){
          this.processArchive(this.dialog.id)
        }else if(this.dialog.actionType == 'unarchive'){
          this.processUnarchive(this.dialog.id)
        }
      },
      processArchives (ids) {
        if(this.archiving){
          return false;
        }
        this.archiving = true
        let self = this

        this.$http.secured.post('/api/admin/channels/archive/'+ ids)
          .then(response => {
            this.getChannels()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.archiving = false
          })
      },
      processArchive (id) {
        this.processArchives(id)
      },
      processUnarchives (ids) {
        if(this.archiving){
          return false;
        }
        this.archiving = true
        let self = this

        this.$http.secured.post('/api/admin/channels/unarchive/'+ ids)
          .then(response => {
            this.getChannels()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.archiving = false
          })
      },
      processUnarchive (id) {
        this.processUnarchives(id)
      },
      updateChannel (){
        if(this.selectedChannel.name == ''){
          this.showMessage('The channel name field is required.', 'sb-failed')
          return false
        }

        if(this.savingChannel){
          return false
        }

        let self = this
        self.savingChannel = true

        let url = '/api/admin/channels/'+this.selectedChannel.id

        let data = {
          id: this.selectedChannel.id,
          name: this.selectedChannel.name
        }

        this.$http.secured.put(url, data)
          .then(response => {
            this.showMessage('Channel has been successfully updated', 'sb-success')
            this.closeModal('modal-edit-channel')
            this.channelName = ''
            this.getChannels()
            this.getDefaultData()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.savingChannel = false
          })
      },
      showChannel (selectedChannel) {
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })
        let tmp = {
          id: selectedChannel.id,
          name: selectedChannel.name
        }
        this.selectedChannel = tmp
        this.showModal('modal-edit-channel')
      },
      addChannel (){
        if(this.channelName == ''){
          this.showMessage('The channel name field is required.', 'sb-failed')
          return false
        }

        if(this.addingChannel){
          return false
        }

        let self = this
        self.addingChannel = true

        let url = '/api/admin/channels'

        let data = {
          name: this.channelName
        }

        this.$http.secured.post(url, data)
          .then(response => {
            this.showMessage('Channel has been successfully created', 'sb-success')
            this.closeModal('modal-add-channel')
            this.channelName = ''
            this.getChannels()
            this.getDefaultData()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.addingChannel = false
          })
      },
      showModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
        this.importFileName = ''
        this.file = ''
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.channelName = ''
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      editItem (id) {
        this.$router.push({ name: 'admin_channel', params: { id: id } })
      },
      cancelDeleteItem () {
        this.deleteDialog.show=false
        this.$refs.table.toggleSelectAll(false);
      },
      deleteItem (item) {
        this.$refs.table.toggleSelectAll(false);
        this.selected = [];
        this.selected.push(item)
        this.deleteDialog.title = 'Delete Channel'
        this.deleteDialog.message = 'Are you sure you want to delete '+item.name+' channel?'
        this.deleteDialog.show = true
      },
      deleteItems () {
        this.deleteDialog.title = 'Delete Selected'
        this.deleteDialog.message = 'Are you sure you want to delete all selected channels?'
        this.deleteDialog.show = true
      },
      confirmDeleteItem () {
        let self = this
        let idx = [];

        Object.keys(this.selected).forEach(key => {
          idx.push(this.selected[key].id)
        })

        this.$http.secured.delete('channels/'+ idx)
          .then(response => {
            if(response.data){
              Object.keys(this.selected).forEach(key => {
                const index = this.channels.indexOf(this.selected[key])
                this.channels.splice(index, 1);
              })

              if(idx.length > 1){
                this.snackbar.text = "Selected channels have been successfully deleted"
              }else{
                this.snackbar.text = this.selected[0].name + " has been successfully deleted"
              }

              this.selected = [];
              this.snackbar.show = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.error = error.response.data
              this.error.show = true
            }else{
              this.snackbar.text = "Something went wrong! Please try again."
              this.snackbar.color = "error"
              this.snackbar.show = true
            }
          })
          .then(function () {
            self.loading = false
            self.deleteDialog.show = false
          })

      },
      getDefaultData () {
        this.$http.plain.get('api/default-data')
          .then(response => {
            this.defaultChannels = response.data.channels
            this.defaultUsers = response.data.users
            this.defaultCountries = response.data.countries
          })
          .catch(error => {
            console.log(error);
          })
      },
      getChannels () {
        this.loading = true
        let self = this
        this.channels = []
        this.$http.plain.get('/api/admin/channels')
          .then(response => {
            this.channels = response.data
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.firstLoad = false
          })
        }
    },
    mounted() {
      this.getChannels()
      this.getDefaultData()
    },
    components: {
      SnackBar,
      BodyLoader,
      ContentLoader,
      ConfirmationDialog,
      ToTop,
      DataPrivacyConsent
    }
  }
</script>
